<template>
  <div id="ParentAdvertMgmt" style="margin: 0 auto; background: white">
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true" show-summary :summary-method="getSummaries" border>
      <el-table-column prop="sku" label="" width="40px" align="right" type="expand" :key="10">
        <template slot-scope="listScope">
          <el-table class="child-table" :ref="'table' + listScope.row._id" :data="listScope.row.campainList" row-key="_id" stripe size="mini" border style="width: 1900px; float: right">
            <el-table-column type="expand" width="40px" align="right">
              <template slot-scope="groupScope">
                <el-table v-if="groupScope.row.spaceAdverts && groupScope.row.spaceAdverts.length > 0" class="child-table" :data="groupScope.row.spaceAdverts" row-key="_id" stripe size="mini" border style="width: 1565px; float: right">
                  <el-table-column prop="Placement" label="广告位置" width="180px" align="right"></el-table-column>
                  <el-table-column prop="Daily Budget" label="竞价调整" width="80px">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.Percentage" @change="onSpacePercentageChange(scope.row)" size="mini"></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column prop="recommandAdjustPercent" label="推荐比例" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="CPC" label="CPC" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Impressions" label="展现量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Clicks" label="点击量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Spend" label="花费" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ Number(scope.row.Spend).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Sales" label="销售额" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ Number(scope.row.Sales).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Orders" label="订单数" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Units" label="销售数量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="ROAS" label="ROAS" width="50px" align="right"> </el-table-column>

                  <el-table-column label="标题" width="50px" align="right">
                    <div>
                      <div class="row-label">近90日</div>
                      <div class="row-label">近30日</div>
                      <div class="row-label">近14日</div>
                      <div>近7日</div>
                    </div>
                  </el-table-column>
                  <el-table-column label="CPC" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayCPC.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayCPC.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayCPC.toFixed(2) }}</div>
                      <div>{{ scope.row.performances.last7DayCPC.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="展现" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayImpressions }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayImpressions }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayImpressions }}</div>
                      <div>{{ scope.row.performances.last7DayImpressions }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayClicks }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayClicks }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayClicks }}</div>
                      <div>{{ scope.row.performances.last7DayClicks }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="订单数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayOrders }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayOrders }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayOrders }}</div>
                      <div>{{ scope.row.performances.last7DayOrders }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayUnits }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayUnits }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayUnits }}</div>
                      <div>{{ scope.row.performances.last7DayUnits }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击率" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ (scope.row.performances.last90DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label">{{ (scope.row.performances.last30DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label">{{ (scope.row.performances.last14DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div>{{ (scope.row.performances.last7DayClickRate * 100).toFixed(2) + "%" }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="转化率" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row.performances, 'last90DayConversionRate')">{{ (scope.row.performances.last90DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row.performances, 'last30DayConversionRate')">{{ (scope.row.performances.last30DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row.performances, 'last14DayConversionRate')">{{ (scope.row.performances.last14DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div :class="getDeliveryConversionRateStyleClass(scope.row.performances, 'last7DayConversionRate')">{{ (scope.row.performances.last7DayConversionRate * 100).toFixed(2) + "%" }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="花费" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DaySpend.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DaySpend.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DaySpend.toFixed(2) }}</div>
                      <div>{{ scope.row.performances.last7DaySpend.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="销售" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DaySales.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DaySales.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DaySales.toFixed(2) }}</div>
                      <div>{{ scope.row.performances.last7DaySales.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROAS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row.performances, 'last90DayROAS')">{{ scope.row.performances.last90DayROAS.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row.performances, 'last30DayROAS')">{{ scope.row.performances.last30DayROAS.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row.performances, 'last14DayROAS')">{{ scope.row.performances.last14DayROAS.toFixed(2) }}</div>
                      <div :class="getDeliveryROASStyleClass(scope.row.performances, 'last7DayROAS')">{{ scope.row.performances.last7DayROAS.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="CPS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.performances.last90DayCPS.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last30DayCPS.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.performances.last14DayCPS.toFixed(2) }}</div>
                      <div>{{ scope.row.performances.last7DayCPS.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="adTypeText" label="广告名称" width="100px" align="right"></el-table-column>
            <el-table-column prop="Daily Budget" label="日预算" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.isDetail" v-model="scope.row['Daily Budget']" @change="onDailyBudgetChange(scope.row)" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="50px" align="right">
              <template slot-scope="scope">
                <el-switch v-if="!scope.row.isDetail" v-model="scope.row.State" @change="onStateChange(scope.row, listScope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="CPC" label="CPC" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Impressions" label="展现量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Clicks" label="点击量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right">
              <template slot-scope="scope">
                {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="Spend" label="花费" width="50px" align="right">
              <template slot-scope="scope">
                {{ Number(scope.row.Spend).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Sales" label="销售额" width="50px" align="right">
              <template slot-scope="scope">
                {{ Number(scope.row.Sales).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Orders" label="订单数" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Units" label="销售数量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right"> </el-table-column>
            <el-table-column prop="ROAS" label="ROAS" width="50px" align="right"> </el-table-column>
            <el-table-column prop="cps" label="CPS" width="50px" align="right">
              <template slot-scope="scope">
                {{ Number(scope.row.cps).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column width="60px" align="right">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.showPermances" @change="onShowPermancesChange(listScope.row._id)">{{ scope.row.showPermances ? "收起" : "展开" }}</el-checkbox>
              </template>
            </el-table-column>

            <el-table-column width="850px">
              <template slot-scope="groupScope">
                <el-table v-show="groupScope.row.showPermances" v-if="groupScope.row.performances && groupScope.row.performances.length > 0" class="child-table" :data="groupScope.row.performances" row-key="_id" default-expand-all stripe size="mini" border style="width: 821px; float: right">
                  <el-table-column prop="delivery" label="广告名称" width="70px" align="right">
                    <template slot-scope="scope">
                      <div>{{ getDeliveryLabel(scope.row.delivery) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="标题" width="50px" align="right">
                    <div>
                      <div class="row-label">近90日</div>
                      <div class="row-label">近30日</div>
                      <div class="row-label">近14日</div>
                      <div>近7日</div>
                    </div>
                  </el-table-column>
                  <el-table-column label="CPC" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayCPC.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last30DayCPC.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last14DayCPC.toFixed(2) }}</div>
                      <div>{{ scope.row.last7DayCPC.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="展现" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayImpressions }}</div>
                      <div class="row-label">{{ scope.row.last30DayImpressions }}</div>
                      <div class="row-label">{{ scope.row.last14DayImpressions }}</div>
                      <div>{{ scope.row.last7DayImpressions }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayClicks }}</div>
                      <div class="row-label">{{ scope.row.last30DayClicks }}</div>
                      <div class="row-label">{{ scope.row.last14DayClicks }}</div>
                      <div>{{ scope.row.last7DayClicks }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="订单数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayOrders }}</div>
                      <div class="row-label">{{ scope.row.last30DayOrders }}</div>
                      <div class="row-label">{{ scope.row.last14DayOrders }}</div>
                      <div>{{ scope.row.last7DayOrders }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayUnits }}</div>
                      <div class="row-label">{{ scope.row.last30DayUnits }}</div>
                      <div class="row-label">{{ scope.row.last14DayUnits }}</div>
                      <div>{{ scope.row.last7DayUnits }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击率" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ (scope.row.last90DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label">{{ (scope.row.last30DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label">{{ (scope.row.last14DayClickRate * 100).toFixed(2) + "%" }}</div>
                      <div>{{ (scope.row.last7DayClickRate * 100).toFixed(2) + "%" }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="转化率" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last90DayConversionRate')">{{ (scope.row.last90DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last30DayConversionRate')">{{ (scope.row.last30DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last14DayConversionRate')">{{ (scope.row.last14DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      <div :class="getDeliveryConversionRateStyleClass(scope.row, 'last7DayConversionRate')">{{ (scope.row.last7DayConversionRate * 100).toFixed(2) + "%" }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="花费" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DaySpend.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last30DaySpend.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last14DaySpend.toFixed(2) }}</div>
                      <div>{{ scope.row.last7DaySpend.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="销售" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DaySales.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last30DaySales.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last14DaySales.toFixed(2) }}</div>
                      <div>{{ scope.row.last7DaySales.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROAS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last90DayROAS')">{{ scope.row.last90DayROAS.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last30DayROAS')">{{ scope.row.last30DayROAS.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last14DayROAS')">{{ scope.row.last14DayROAS.toFixed(2) }}</div>
                      <div :class="getDeliveryROASStyleClass(scope.row, 'last7DayROAS')">{{ scope.row.last7DayROAS.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="CPS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayCPS.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last30DayCPS.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last14DayCPS.toFixed(2) }}</div>
                      <div>{{ scope.row.last7DayCPS.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="毛利" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label">{{ scope.row.last90DayGrossIncome.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last30DayGrossIncome.toFixed(2) }}</div>
                      <div class="row-label">{{ scope.row.last14DayGrossIncome.toFixed(2) }}</div>
                      <div>{{ scope.row.last7DayGrossIncome.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="净利" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last90DayNetIncome')">{{ scope.row.last90DayNetIncome.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last30DayNetIncome')">{{ scope.row.last30DayNetIncome.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last14DayNetIncome')">{{ scope.row.last14DayNetIncome.toFixed(2) }}</div>
                      <div :class="getDeliveryNetIncomeStyleClass(scope.row, 'last7DayNetIncome')">{{ scope.row.last7DayNetIncome.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROI" width="50px" align="right">
                    <template slot-scope="scope">
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last90DayROI')">{{ scope.row.last90DayROI.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last30DayROI')">{{ scope.row.last30DayROI.toFixed(2) }}</div>
                      <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last14DayROI')">{{ scope.row.last14DayROI.toFixed(2) }}</div>
                      <div :class="getDeliveryNetIncomeStyleClass(scope.row, 'last7DayROI')">{{ scope.row.last7DayROI.toFixed(2) }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="名称" width="100px" align="right" :key="12" sortable> </el-table-column>
      <el-table-column prop="model" label="机型" width="60px" align="right" v-if="viewModel == 2" :key="13" sortable> </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="60px" align="right" v-if="viewModel == 2" :key="14" sortable> </el-table-column>
      <el-table-column prop="speed" label="增速" width="40px" align="right" :key="15" sortable> </el-table-column>
      <el-table-column prop="inventoryCount" label="库存" width="40px" align="right" :key="16" sortable> </el-table-column>
      <el-table-column prop="availableQuantity" label="可用" width="40px" style="color: green" align="right" :key="17" sortable>
        <template v-slot="scope">
          <div class="greenText">{{ scope.row.availableQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reservedQuantity" label="预留" width="40px" style="color: greenyellow" align="right" :key="18" sortable>
        <template v-slot="scope">
          <div class="greenYellowText">{{ scope.row.reservedQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" :key="19" sortable> </el-table-column>
      <el-table-column prop="inboundWorking" label="处理中" width="40px" align="right" v-if="viewModel == 2" :key="110" sortable> </el-table-column>
      <el-table-column prop="inboundShipped" label="已发货" width="40px" align="right" v-if="viewModel == 2" :key="111" sortable> </el-table-column>
      <el-table-column prop="inboundReceived" label="正在接收" width="40px" style="color: goldenrod" align="right" v-if="viewModel == 2" :key="112" sortable>
        <template v-slot="scope">
          <div class="yellowText">{{ scope.row.inboundReceived }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" :key="113" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" :key="114" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalVisit" label="合计访客" width="55px" align="right" :key="115" sortable> </el-table-column>
      <el-table-column prop="orderRate" label="转化率" width="50px" align="right" :key="116" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate >= 0 ? Math.round(scope.row.orderRate * 10000) / 100 + "%" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalOrder" label="合计订单" width="55px" align="right" :key="117" sortable> </el-table-column>
      <el-table-column prop="last7DayCount" label="七日订单" width="55px" align="right" :key="118" sortable> </el-table-column>
      <el-table-column prop="lastDayCount" label="昨日订单" width="55px" align="right" :key="1181" sortable> </el-table-column>
      <el-table-column prop="grossIncome" label="昨日毛利" width="55px" align="right" :key="1281" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.grossIncome.toFixed(2) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="netIncome" label="昨日净利" width="55px" align="right" :key="12811" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.netIncome.toFixed(2) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="40px" align="right" :key="119" sortable> </el-table-column>
      <el-table-column prop="Daily Budget" label="每日预算" width="40px" align="right" :key="1191" sortable> </el-table-column>
      <!-- <el-table-column prop="majorLevel" label="等级" width="40px" align="right" :key="120" sortable>
        <template v-slot="scope">
          <div :class="getMajorLevelStyleClass(scope.row)">{{ scope.row.majorLevel>0 ? scope.row.majorLevel : "" }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="State" label="推荐状态" width="80px" align="right" :key="1200" sortable>
        <template v-slot="scope">
          <div :class="getRecommendStyleClass(scope.row)">{{ getRecommendState(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="50px" align="right" :key="121" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.State" @change="onProductStateChange(scope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="50px" :key="122">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="productDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="CPC" label="CPC" width="50px" align="right" :key="123" sortable> </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="50px" align="right" :key="124" sortable> </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="50px" align="right" :key="125" sortable> </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" :key="126" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" :key="127" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.Spend).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" :key="128" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.Sales).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="50px" align="right" :key="129" sortable> </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="50px" align="right" :key="130" sortable> </el-table-column>
      <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right" :key="131" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row["Conversion Rate"]).toFixed(4) }}
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="50px" align="right" :key="132" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.ROAS).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="cps" label="CPS" width="50px" align="right" :key="13234232" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.cps).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column width="145px" :key="132121"> </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 68,
      total: 0,
      pageCount: 1,
      sku: "",
      productType: "1",
      productColor: "",
      advertData: [],
      productList: activeProducts,
      colorList: colors,
      viewModel: "1",
      params: { pageSize: 200, sku: this.sku, typeList: "1|2|3|4", date: new Date().format("yyyy-MM-dd"), beginIndex: 0, productColor: "黑色" },
    };
  },
  components: {},
  mounted() {
    this.getAdvertData();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 68;
    },
    onShowPermancesChange(id) {
      this.$nextTick(() => {
        this.$refs["table" + id].doLayout();
      });
    },
    onStateChange(row, listRow) {
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });

      let state = "已暂停";
      listRow.campainList.forEach(advert => {
        advert.State == "已启用" && (state = "已启用");
      });
      listRow.State = state;
    },
    onProductStateChange(row) {
      let campainList = row.campainList;
      campainList.forEach(campain => {
        campain.State = row.State;
        let params = {
          id: campain._id,
          State: row.State,
        };
        requestModules.updateProductAdvert(params).then(res => {});
      });
      this.$message({
        type: "success",
        message: "修改成功!",
      });
    },
    onDailyBudgetChange(row) {
      this.$confirm("是否确认修改每日预算?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            "Daily Budget": row["Daily Budget"],
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onSpacePercentageChange(row) {
      this.$confirm("是否确认修改竞价比例?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Percentage: row.Percentage,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    detailPage(row) {
      window.open("/client/keywordAdvertDetail?asin=" + row.asin);
    },
    searchKeydetailPage(row) {
      window.open("/client/searchKeywordMgmt?asin=" + row.asin);
    },
    getAdvertData() {
      requestModules.fetchParentProductAdverts(this.params).then(res => {
        this.advertData = res.ldata;
        this.total = res.total;
        this.pageCount = Math.ceil(this.total / this.params.pageSize) || 1;

        this.advertData.forEach(ad => {
          ad.campainList.forEach(item => (item.showPermances = false));
        });
      });
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendStyleClass(row) {
      let state = this.getRecommendState(row);
      let styleClass = "";
      if (state != row.State) {
        state == "enabled" && (styleClass = "greenBg");
        state == "enabled" && row.price > 8.5 && (styleClass = "yellowBg");
        state == "paused" && (styleClass = "redBg");
        state == "paused" && row.price < 6.5 && (styleClass = "yellowBg");
      }
      return styleClass;
    },
    getMajorLevelStyleClass(row) {
      let styleClass = "";
      row.majorLevel == "1" && (styleClass = "greenBg");
      row.majorLevel == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getRecommendState(row) {
      let state = "paused";
      let { totalVisit, orderRate, totalCount, availableInventoryDay, inventoryDay, inventoryCount, reservedQuantity, speed } = { ...row };
      if (availableInventoryDay >= 90 && Number(inventoryCount) + Number(reservedQuantity) > 30) {
        state = "enabled";
      } else {
        if (speed < 0 && availableInventoryDay >= 60 && orderRate >= 0.08 && totalVisit > 100) {
          state = "enabled";
        }
      }
      // inventoryDay == 10000 && inventoryCount > 10 && (state = "enabled");
      // availableInventoryDay >= 90 && orderRate >= 0.08 && totalVisit < 100 && (state = "enabled");
      return state;
    },
    getRecommandBidStyleClass(row) {
      let styleClass = "";
      if (!row) {
        return;
      }
      row.recommandBid > row.Bid && (styleClass = "greenBg");
      row.recommandBid < row.Bid && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryConversionRateStyleClass(row, key) {
      if (!row) {
        return "";
      }
      let conversionRate = row[key];
      let styleClass = "";
      conversionRate >= 0.15 && (styleClass = "greenBg");
      conversionRate < 0.1 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryROASStyleClass(row, key) {
      if (!row) {
        return "";
      }
      let roas = row[key];
      let styleClass = "";
      roas >= 3 && (styleClass = "greenBg");
      roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryNetIncomeStyleClass(row, key) {
      if (!row) {
        return "";
      }
      let netIncome = row[key];
      let styleClass = "";
      netIncome > 0 && (styleClass = "greenBg");
      netIncome < 0 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryLabel(delivery) {
      let label = "";
      delivery == "close-match" && (label = "紧密匹配");
      delivery == "loose-match" && (label = "宽泛匹配");
      delivery == "substitutes" && (label = "同类商品");
      delivery == "complements" && (label = "关联商品");
      console.log(delivery, label);
      return label;
    },
    productDetail(row) {
      window.open("/client/productDetail?asin=" + row.asin);
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    load(tree, treeNode, resolve) {
      let params = { pageSize: 100, campaignName: tree["Campaign Name (Informational only)"], adGroupName: tree["Ad Group Name (Informational only)"] };
      requestModules.fetchDetailProductAds(params).then(res => {
        let list = res.ldata;
        list.forEach(item => {
          item.Bid = "";
          item.relateAdvert = {};
          item.isDetail = true;
        });
        resolve(list);
      });
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      let totalVisit = 0;
      let totalOrder = 0;
      let impressions = 0;
      let clicks = 0;
      let orders = 0;
      let spend = 0;
      let sales = 0;
      const skipSumProps = new Set([
        "orderRate",
        "Click-through Rate",
        "Conversion Rate",
        "ROAS",
        "CPC",
        "cps",
        "price",
        "Daily Budget",
        "majorLevel",
        "speed",
        "inventoryDay",
        "availableInventoryDay",
      ]);

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (!column.property || skipSumProps.has(column.property)) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        } else {
          sums[index] = "";
        }
        column.property === "totalVisit" && (totalVisit = sums[index]);
        column.property === "totalOrder" && (totalOrder = sums[index]);
        column.property === "Impressions" && (impressions = sums[index]);
        column.property === "Clicks" && (clicks = sums[index]);
        column.property === "Orders" && (orders = sums[index]);
        column.property === "Spend" && (spend = sums[index]);
        column.property === "Sales" && (sales = sums[index]);
      });

      columns.forEach((column, index) => {
        if (column.property === "orderRate") {
          sums[index] = totalVisit > 0 ? (Math.round((totalOrder / totalVisit) * 10000) / 100).toFixed(2) + "%" : "";
        }
        if (column.property === "Click-through Rate") {
          sums[index] = impressions > 0 ? ((clicks / impressions) * 100).toFixed(2) + "%" : "";
        }
        if (column.property === "Conversion Rate") {
          sums[index] = clicks > 0 ? (orders / clicks).toFixed(4) : "";
        }
        if (column.property === "ROAS") {
          sums[index] = spend > 0 ? (sales / spend).toFixed(2) : "";
        }
        if (column.property === "CPC") {
          sums[index] = clicks > 0 ? (spend / clicks).toFixed(2) : "";
        }
        if (column.property === "cps") {
          sums[index] = orders > 0 ? (spend / orders).toFixed(2) : "";
        }
        if ((column.property === "Spend" || column.property === "Sales" || column.property === "grossIncome" || column.property === "netIncome") && sums[index] !== "") {
          sums[index] = Number(sums[index]).toFixed(2);
        }
      });
      return sums;
    },
  },
  computed: {
    tableData() {
      let list = [...this.advertData];
      list.forEach(advert => {
        advert.campainList.forEach(ad => (ad.hasChildren = true));
        advert.inventoryCount = parseInt(advert.inventoryCount);
        advert.reservedQuantity = parseInt(advert.reservedQuantity);
        advert.inboundQuantity = parseInt(advert.inboundQuantity);
        advert.inventoryDay = parseInt(advert.inventoryDay);
        advert.availableInventoryDay = parseInt(advert.availableInventoryDay);
      });
      // this.productType != "" && (list = list.filter(advert => advert.productType == this.productType));
      // this.productColor != "" && (list = list.filter(advert => advert.color == this.productColor));
      list.sort((a, b) => b.Spend - a.Spend);
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });

      return list;
    },
  },
};
</script>

<style lang="scss">
#ParentAdvertMgmt {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
